<template>
    <div class="bill-group">
        <div class="bill-total">
            <span>Total bill:</span>
            <span>25 zł</span>
        </div>
        <ul>
            <CartItemBill v-for="item in items" :key="item.id" :item="item" />
        </ul>
    </div>
</template>

<script>
import CartItemBill from './CartItemBill.vue';

export default {
    name: "CartBill",
    components: {
        CartItemBill,
    },
    props: {
        items: Array,
    },
    data() {
        return {}
    },
}
</script>

<style lang="scss" scoped>
@import "src/scss/assets/variables";

ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.bill-group {
    padding: 12px;
    margin-bottom: 12px;

    border: 2px solid $color_mercury;
    border-radius: 40px 40px 0 0;

    box-shadow: 0px 4px 30px 0px #0000001A;

}

.bill-total {
    display: flex;
    justify-content: space-between;

    padding: 10px;

    font-weight: 700;
    font-size: 16px;

    border-bottom: 1px solid $color_mercury;

    color: black;
}
</style>